import { render, staticRenderFns } from "./item-num.vue?vue&type=template&id=4702fba2&scoped=true&"
import script from "./item-num.vue?vue&type=script&lang=js&"
export * from "./item-num.vue?vue&type=script&lang=js&"
import style0 from "./item-num.vue?vue&type=style&index=0&id=4702fba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4702fba2",
  null
  
)

export default component.exports